package ru.it_mozaika.sender.js.application.context

import js.core.jso
import mui.material.Backdrop
import mui.material.CircularProgress
import mui.material.CircularProgressColor
import mui.system.sx
import react.*
import web.cssom.Color
import web.cssom.integer

external interface BackdropContextInterface {
    var show: () -> Unit
    var hide: () -> Unit
}

val BackdropContext = createContext<BackdropContextInterface>(jso {
    show = {}
    hide = {}
})
val BackdropProvider = FC<PropsWithChildren> { props ->
    var showBackdrop by useState(false)
    BackdropContext.Provider {
        value = jso {
            show = { showBackdrop = true }
            hide = { showBackdrop = false }
        }
        Backdrop {
            sx {
                color = Color("#fff")
                zIndex = integer(1_250)
            }
            open = showBackdrop

            onClick = { it.stopPropagation() }
            CircularProgress {
                color = CircularProgressColor.inherit
            }
        }
        +props.children
    }
}

fun useBackdrop() = useContext(BackdropContext)